import { useCallback } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";

export type PrincipleFormValues = {
  budget: number;
  riskRewardRatio: string;
  maximumRiskLimit: number;
  symbol: string;
  currentPrice: number;
  atr: number;
};

export const useInitialValues = () => {
  return {
    budget: 10000,
    riskRewardRatio: '1:2',
    maximumRiskLimit: 2,
    symbol: 'AAPL',
    currentPrice: 0,
    atr: 5.04,
  }
}

export const useValidate = () => useCallback((values) => {
  const errors = {};
  // if (!values.email) {
  //   errors.email = 'Required';
  // } else if (
  //   !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
  // ) {
  //   errors.email = 'Invalid email address';
  // }
  return errors;
}, []);

const HISTORY_KEY = 'principle-history';

export const usePrincipleSubmit = () => {
  const { mutate: save } = usePrincipleHistoryMutation();
  return useCallback(async (values: PrincipleFormValues) => {
    const riskRewardRatio = Number(values.riskRewardRatio.split(':')[1]);
    const riskLimit = values.budget * values.maximumRiskLimit / 100;
    const riskPerShare = values.atr * 1.3;
    const stopLossPrice = values.currentPrice - riskPerShare;
    const takeProfitPrice = values.currentPrice + riskPerShare * riskRewardRatio;
    const caclcedSharesToBuy = Math.floor(riskLimit / riskPerShare);
    const sharesToBuy = values.currentPrice > riskLimit ? 0 : caclcedSharesToBuy;

    save({
      date: new Date().getTime(),
      symbol: values.symbol,
      shares: sharesToBuy,
      currentPrice: values.currentPrice,
      stopLossPrice,
      takeProfitPrice,
    });
  }, [save]);
}

export type PrincipleHistoryType = {
  date: number;
  symbol: string;
  shares: number;
  currentPrice: number;
  stopLossPrice: number;
  takeProfitPrice: number;
}

export const usePrincipleHistoryMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(async (payload: PrincipleHistoryType) => {
    const histories = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');
    if (histories.length > 20) {
      histories.shift();
    }
    histories.push(payload);
    localStorage.setItem(HISTORY_KEY, JSON.stringify(histories));
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries([HISTORY_KEY]);
    }
  });
}

export const usePrincipleHistoryQuery = () => useQuery([HISTORY_KEY], async () => {
  const histories = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');
  return histories.reverse();
});

export const usePricipleHistoryReset = () => {
  const queryClient = useQueryClient();
  return useCallback(() => {
    localStorage.removeItem(HISTORY_KEY);
    queryClient.invalidateQueries([HISTORY_KEY]);
  }, [queryClient]);
}